var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-material-card',{attrs:{"icon":_vm.resource.icon,"title":_vm.title}},[_c('v-data-table',{attrs:{"headers":_vm.fields,"items":_vm.jsonData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }